<template>
  <el-form :model="form" :rules="rules"></el-form>
</template>

<script>
import { getRevenueNewList } from '@/api/enterprise'

export default {
  props: ['ans', 'cb', 'userId'],
  data () {
    return {
      form: {},
      rules: {}
    }
  },
  mounted () {
    if (this.ans.version) {
      this.form = { result: this.ans.result, version: this.ans.version, year: this.ans.year, thisYear: this.ans.thisYear, lastYear: this.ans.lastYear }
    } else if (this.ans.thisYear && this.ans.lastYear) {
      this.form = { result: this.ans.result, thisYear: this.ans.thisYear, lastYear: this.ans.lastYear }
    } else {
      this.loadYear()
    }
  },
  methods: {
    loadYear () {
      getRevenueNewList(this.userId).then(res => {
        const revenue = res.data.sort((a, b) => a.year * 1 > b.year * 1 ? 1 : -1)
        const { personRevenue: personRevenue2023, profit: profit2023, year: year2023 } = revenue[2]
        const { personRevenue: personRevenue2022, profit: profit2022, year: year2022 } = revenue[1]
        const cost2023 = personRevenue2023 - profit2023
        const cost2022 = personRevenue2022 - profit2022
        const beforeCost = personRevenue2022 === 0 ? 0 : (cost2022 / personRevenue2022)
        const afterCost = personRevenue2022 === 0 ? 0 : (cost2023 / personRevenue2023)
        const result = afterCost > beforeCost ? 1 : (afterCost === beforeCost ? 0 : -1)
        this.form = { result, version: 1, year: [year2022, year2023], thisYear: { personRevenue: personRevenue2023, profit: profit2023, cost: cost2023, perCost: afterCost.toFixed(3) }, lastYear: { personRevenue: personRevenue2022, profit: profit2022, cost: cost2022, perCost: beforeCost.toFixed(3) } }
        this.cb(this.form, year2023)
      })
    }
  }
}
</script>
